// extracted by mini-css-extract-plugin
export default {"charts":"charts_charts__DL6F-","chartsTitle":"charts_chartsTitle__mAtX9","chart":"charts_chart__J07bz","chartsTopBlock":"charts_chartsTopBlock__RFywL"};